import type { Option } from "@tento-lona/sheets";
import { RowNetworkKey } from "@tento-lona/sheets";

/**
 * Which weather location a surface shows, read only from what someone chose:
 * a stored preference or a row's own location. Nothing chosen means no
 * location, never a table default.
 */
export namespace WeatherLocationChoice {
  /**
   * The location id the `defaultWeatherLocation` preference names; `null`
   * when it is unset or not a location id. Unset is not "no location": the
   * default weather row then follows the viewer's place (or names none), which
   * its resolved weather renderer reports.
   */
  export function ofPreference(raw: Option<string>): Option<number> {
    if (raw == null) return null;
    const parsed = Number(raw);
    return Number.isFinite(parsed) && String(parsed) === raw ? parsed : null;
  }

  /**
   * The weather row a preview or subtitle reads: the given key, else the
   * location's canonical weather row (`RowNetworkKey.weatherDataKey`, the
   * `:~weather:{lid}` row the sheet's weather cells bind); `null` (nothing
   * to read) when neither names a location.
   */
  export function previewRowKey(props: { lid?: Option<number>; rowKey?: Option<string> }): Option<string> {
    if (props.rowKey != null) return props.rowKey;
    return props.lid == null ? null : RowNetworkKey.weatherDataKey(String(props.lid));
  }
}
